import { render, staticRenderFns } from "./wxlist.vue?vue&type=template&id=d2de94e0&scoped=true"
import script from "./wxlist.vue?vue&type=script&lang=js"
export * from "./wxlist.vue?vue&type=script&lang=js"
import style0 from "./wxlist.vue?vue&type=style&index=0&id=d2de94e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2de94e0",
  null
  
)

export default component.exports